import { useEffect, useState } from 'react';
import Cookies from 'react-cookies';
import { useAsync } from 'react-use';
import { Grid } from 'antd';
import { ButtonOK } from 'src/components/Forms/Button';
import ImageC from 'src/components/Image';
import g from 'src/constants/urls';
import ReadArticleContainer from 'src/containers/ReadArticle';
import { decryptDLoginBE } from 'src/utils/func/encrypt';
import { formatDateResultPregnancy } from 'src/utils/func/kalender-kehamilan';
import DisclaimerResultHpl from '../DisclaimerResultHpl';
import style from './style.module.less';
const KehamilanResult = (props: any) => {
  const {
    xs
  } = Grid.useBreakpoint();
  const {
    listDay,
    onRetest
  } = props;
  const [artikel, setDataArtikel] = useState<any>([]);
  useAsync(async () => {
    const filtersLike = 'order=desc&orderby=publish_date&per_page=3&page=1';
    try {
      const newArtikel = `${g.API_ARTICLE}/pregnancy?${filtersLike}`;
      const optsS2 = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };
      const artikelFeedback = await fetch(newArtikel, optsS2);
      const dataNewArtikel = await artikelFeedback.json();
      dataNewArtikel.status = artikelFeedback.status;
      if (dataNewArtikel.status === 200) {
        setDataArtikel(dataNewArtikel.data);
      }
    } catch (error) {}
  }, []);
  const [dataLogin, setDataLogin] = useState<any>({});
  useEffect(() => {
    if (Cookies.load('d_login')) {
      const fetchData = async () => {
        const userData = decryptDLoginBE(Cookies.load('d_login'));
        setDataLogin(userData);
      };
      fetchData();
    } else {}
  }, []);
  return <div className={style.result}>
			<h3 style={{
      opacity: !dataLogin.uid ? 0.2 : 1,
      fontSize: '24px'
    }}>Timeline Kehamilan</h3>
			<div className={`${style.item} d-block  d-md-flex `} style={{
      opacity: !dataLogin.uid ? 0.1 : 1
    }}>
				<div style={{
        overflow: 'hidden',
        width: '100%'
      }}>
					<div style={{
          float: 'left',
          width: '50%'
        }}>
						<h4>Trimester 1</h4>
					</div>
					<div style={{
          float: 'right',
          width: '50%',
          textAlign: 'end'
        }}>
						<p>{formatDateResultPregnancy(listDay?.trimester_1?.start_date) + ' - ' + formatDateResultPregnancy(listDay?.trimester_1?.end_date)}</p>
					</div>
				</div>
			</div>
			<div className={`${style.item} d-block  d-md-flex `} style={{
      opacity: !dataLogin.uid ? 0.1 : 1
    }}>
				<div style={{
        overflow: 'hidden',
        width: '100%'
      }}>
					<div style={{
          float: 'left',
          width: '50%'
        }}>
						<h4>Trimester 2</h4>
					</div>
					<div style={{
          float: 'right',
          width: '50%',
          textAlign: 'end'
        }}>
						<p>{formatDateResultPregnancy(listDay?.trimester_2?.start_date) + ' - ' + formatDateResultPregnancy(listDay?.trimester_2?.end_date)}</p>
					</div>
				</div>
			</div>
			{!dataLogin.uid ? <div className={style.calendarContent} style={{
      backgroundColor: '#ffffff',
      display: !dataLogin.uid ? 'block' : 'none',
      textAlign: 'center'
    }}>
						<ImageC src="/images/kalender-hpl/result-hpl.webp" height={xs ? 180 : 250} width={xs ? 180 : 250} />
						<p className={style.paragraph} style={{
        textAlign: 'center'
      }}>
							Yuk, Ma login sekarang buat buka akses perhitungannya
						</p>
						<ButtonOK style={{
        borderRadius: '16px'
      }} htmlType="submit" text={'Login Sekarang'} href="/login" />
					</div> : <div>
						<div className={`${style.item} d-block  d-md-flex `}>
							<div style={{
          overflow: 'hidden',
          width: '100%'
        }}>
								<div style={{
            float: 'left',
            width: '50%'
          }}>
									<h4>Trimester 3</h4>
								</div>
								<div style={{
            float: 'right',
            width: '50%',
            textAlign: 'end'
          }}>
									<p>{formatDateResultPregnancy(listDay?.trimester_3?.start_date) + ' - ' + formatDateResultPregnancy(listDay?.trimester_3?.end_date)}</p>
								</div>
							</div>
						</div>
						<div className={`${style.item} ${style.pink} d-block d-md-flex`}>
							<div style={{
          overflow: 'hidden',
          width: '100%'
        }}>
								<div style={{
            float: 'left',
            width: '50%'
          }}>
									<h4>Hari Perkiraan Lahir</h4>
								</div>
								<div style={{
            float: 'right',
            width: '50%',
            textAlign: 'end'
          }}>
									<p>{formatDateResultPregnancy(listDay?.hpl_date)}</p>
								</div>
							</div>
						</div>
						<div className={`${style.item} d-block d-md-flex `}>
							<div style={{
          overflow: 'hidden',
          width: '100%'
        }}>
								<div style={{
            float: 'left',
            width: '50%'
          }}>
									<h4>Perkiraan Siap Dilahirkan</h4>
								</div>
								<div style={{
            float: 'right',
            width: '50%',
            textAlign: 'end'
          }}>
									<p>{formatDateResultPregnancy(listDay?.birth_date_prediction?.start_date) + ' - ' + formatDateResultPregnancy(listDay?.birth_date_prediction?.end_date)}</p>
								</div>
							</div>
						</div>
						<div>
							<DisclaimerResultHpl {...listDay} />
						</div>
						<div className={style.calendarButton}>
							<button onClick={onRetest} className={style.firstButton}>
								Hitung Ulang
							</button>
						</div>
					</div>}
			<div>
				{!dataLogin.uid ? '' : <ReadArticleContainer {...artikel} />}
			</div>
		</div>;
};
export default KehamilanResult;